import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_BY_SLUG_REQUEST = 'priceGroupTierAccess/FETCH_BY_SLUG_REQUEST'
const FETCH_BY_SLUG_SUCCESS = 'priceGroupTierAccess/FETCH_BY_SLUG_SUCCESS'
const FETCH_BY_SLUG_FAILURE = 'priceGroupTierAccess/FETCH_BY_SLUG_FAILURE'

// Initialize State
const initialState = {
  loadingSlugs: {},
  bySlug: {}
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BY_SLUG_REQUEST:
      return {
        ...state,
        loadingSlugs: { ...state.loadingSlugs, [action.slug]: true }
      }
    case FETCH_BY_SLUG_SUCCESS:
      return {
        ...state,
        loadingSlugs: { ...state.loadingSlugs, [action.slug]: false },
        bySlug: {
          ...state.bySlug,
          [action.slug]: action.payload.map((item) => item.tier)
        }
      }
    case FETCH_BY_SLUG_FAILURE:
      return {
        ...state,
        loadingSlugs: { ...state.loadingSlugs, [action.slug]: false }
      }
    default:
      return state
  }
}

export const getTierAccessBySlug = (slug) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_BY_SLUG_REQUEST, slug })
      const response = await API.get(
        `${EndPoints.PRICE_GROUP_TIER_ACCESS_BY_SLUG}?slug=${encodeURIComponent(
          slug
        )}`
      )
      dispatch({
        type: FETCH_BY_SLUG_SUCCESS,
        slug,
        payload: response.data
      })
      return response.data.map((item) => item.tier)
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      dispatch({ type: FETCH_BY_SLUG_FAILURE, slug })
      return null
    }
  }
}

export const grantTierAccess = (tier, slug) => {
  return async () => {
    try {
      await API.post(EndPoints.PRICE_GROUP_TIER_ACCESS, { tier, slug })
      return true
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      return false
    }
  }
}

export const revokeTierAccess = (tier, slug) => {
  return async () => {
    try {
      await API.request({
        method: 'delete',
        url: EndPoints.PRICE_GROUP_TIER_ACCESS,
        data: { tier, slug }
      })
      return true
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      return false
    }
  }
}
